import type { WorkflowRun, WorkflowRunStatus } from '../../api/workflowRuns'

const WORKFLOW_RUN_STATUS_LABEL: Record<WorkflowRunStatus, string> = {
  queued: '排队中',
  running: '运行中',
  awaiting_input: '等待输入',
  succeeded: '已完成',
  failed: '失败',
  cancelled: '已取消',
}

const WORKFLOW_RUN_STEP_STATUS_LABEL: Record<string, string> = {
  queued: '排队',
  running: '执行中',
  awaiting_input: '等待输入',
  succeeded: '完成',
  failed: '失败',
  cancelled: '取消',
}

export function workflowRunStatusLabel(status: string): string {
  const key = status.trim().toLowerCase() as WorkflowRunStatus
  return WORKFLOW_RUN_STATUS_LABEL[key] ?? status
}

export function workflowRunStepStatusLabel(status: string): string {
  const key = status.trim().toLowerCase()
  return WORKFLOW_RUN_STEP_STATUS_LABEL[key] ?? status
}

function looksLikeHttpUrl(value: string): boolean {
  const trimmed = value.trim()
  return /^https?:\/\//i.test(trimmed)
}

function collectUrlsFromValue(value: unknown, urls: Set<string>): void {
  if (typeof value === 'string') {
    if (looksLikeHttpUrl(value)) urls.add(value.trim())
    return
  }
  if (Array.isArray(value)) {
    for (const item of value) collectUrlsFromValue(item, urls)
    return
  }
  if (value && typeof value === 'object') {
    for (const item of Object.values(value as Record<string, unknown>)) {
      collectUrlsFromValue(item, urls)
    }
  }
}

export function collectWorkflowImageUrls(run: WorkflowRun): string[] {
  const urls = new Set<string>()
  for (const step of run.steps) {
    collectUrlsFromValue(step.output, urls)
  }
  collectUrlsFromValue(run.output, urls)
  return [...urls]
}

export function extractWorkflowTextSnippets(run: WorkflowRun, maxLength = 280): string[] {
  const snippets: string[] = []
  const seen = new Set<string>()

  function pushText(raw: unknown) {
    if (typeof raw !== 'string') return
    const text = raw.trim()
    if (!text || seen.has(text) || looksLikeHttpUrl(text)) return
    seen.add(text)
    snippets.push(text.length > maxLength ? `${text.slice(0, maxLength)}…` : text)
  }

  for (const step of run.steps) {
    if (step.nodeType === 'llm.prompt') {
      pushText(step.output.prompt)
      pushText(step.output.llmOutput)
    }
    if (step.nodeType === 'text.rewrite') {
      pushText(step.output.prompt)
    }
  }

  return snippets
}

export function isWorkflowRunActive(status: string): boolean {
  const key = status.trim().toLowerCase()
  return key === 'queued' || key === 'running' || key === 'awaiting_input'
}
